import getClipboard from "./getClipboard";
import setClipboard from "./setClipboard";
export { getClipboard, setClipboard };
export default {
  getClipboard: getClipboard,
  setClipboard: setClipboard
};